import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clp/htdocs/mcjfe-app/node_modules/@mui/material/esm/CssBaseline/CssBaseline.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clp/htdocs/mcjfe-app/src/app/clientLayoutWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/home/clp/htdocs/mcjfe-app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clp/htdocs/mcjfe-app/src/components/customLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/home/clp/htdocs/mcjfe-app/src/components/providers/appContext/settingsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clp/htdocs/mcjfe-app/src/components/providers/localesContext/localesProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clp/htdocs/mcjfe-app/src/components/providers/snackbarProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clp/htdocs/mcjfe-app/src/components/providers/storeContext/reduxStoreProvers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clp/htdocs/mcjfe-app/src/components/providers/themeContext/themeContextProvider.tsx");
